import {createSlice} from '@reduxjs/toolkit';
import Config from '../../../Config';
import {buildUrl} from '../../../utilities/StringHelpers/StringHelpers';

const initialState = {
  blockData: {
    blockId: 0,
  },
  page: 'operationsAreasPage',
};

const operationsAreasBlockSlice = createSlice({
  name: 'operationsAreasBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.blockData = action.payload.blockData;

      },
      prepare: (action) => {
        let payload = {};
        const blockData = action.blockData;

        let blockDataObj = {
          blockId: blockData.contentLink.id,
          backgroundImageDesktop : blockData.backgroundImageDesktop.value?.url,
          backgroundImageMobile : blockData.backgroundImageMobile.value?.url,
          titleOperationsList: blockData.titleOperationsList?.value,
          subTitleNoMessage: blockData.subTitleNoMessage?.value,
          subTitleOneMessage: blockData.subTitleOneMessage?.value,
          subTitleMoreThenOneMessage: blockData.subTitleMoreThenOneMessage?.value,
          operationAreas: blockData.operationAreas?.expandedValue?.map((area) => ({
            areaName: area.areaName?.value,
            icon: area.icon?.value,
            showMoreThreshold: area.showMoreThreshold?.value,
            actionType: area.actionType?.value?.split(',').map((s) => s.trim()) ?? null,
            actionItems: area.actionItems?.expandedValue?.map((item) => ({
              link: item.link?.value,
              linkTitle: item.linkTitle?.value,
              itemImage: item.itemImage?.value,
              badgeTitle: item.badgeTitle?.value,
              showBadge: item.showBadge?.value,
              badgeColor: item.badgeColor?.value,
            })),
          })),
        };

        payload.blockData = blockDataObj;
        return {payload: payload};

      },
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    reportDWH: (state, action) => {}
  },
  extraReducers: {

  },
});

export const {
    resetBlock,
    initBlock,
    goToPage,
    reportDWH

} = operationsAreasBlockSlice.actions;

export default operationsAreasBlockSlice.reducer;
